(function () {
    'use strict';

    angular.module("imApp").factory("capTaskPlansService", ['$ihttp', function ($ihttp) {
        var service = {
            getCapacityTaskPlans: function (parms) {
                return $ihttp.post({
                    method: 2074,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();